/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React, { useContext, useEffect, useRef } from "react";
import { graphql } from "gatsby";
import { AppContext } from "~context/AppContext";
import Footer from "~components/Footer";
import Layout from "~components/Layout";
import PortableText from "~components/PortableText.jsx";
import SEO from "~components/SEO";

const TermsPage = ({ data, location }) => {
  const { termsLink, setTermsLink } = useContext(AppContext);

  //

  const cms = data.sanityTerms;

  const textGroups = {};

  if (cms?.textGroups) {
    cms.textGroups.forEach(textGroup => {
      textGroup.ref = useRef();
      textGroups[textGroup.id] = textGroup;
    });
  }

  const textGroupKeys = Object.keys(textGroups);

  //

  useEffect(() => {
    if (termsLink) {
      if (Object.keys(textGroups)?.[0] && textGroups?.[termsLink]) {
        const preloadedTextGroup = textGroups[termsLink];

        if (preloadedTextGroup?.ref?.current) {
          const top = preloadedTextGroup.ref.current.offsetTop - 90;

          window.scrollTo({
            top,
            behavior: `smooth`
          });
        }
      }

      setTermsLink(null);
    }
  }, [termsLink]);

  //

  return (
    <>
      <SEO
        customTitle={cms?.title}
        customDescription={cms?.seoDescription}
        customKeywords={cms?.seoKeywords}
        path={location.pathname}
      />

      <Layout className="terms-page w-full relative">
        {/* <DummyImage /> */}

        <section className="w-full relative block pb-24 bg-bone">
          <article className="grid">
            <h1 className="grid-end-12 md:grid-end-8 md:grid-start-3 mt-24 md:mt-32 f2 text-center">
              {cms.title}
            </h1>

            {/* <div className="grid-end-12 md:grid-end-8 md:grid-start-3 mt-8 whitespace-pre-wrap b1 text-left">
              {cms?._rawBody && <PortableText blocks={cms._rawBody} />}
            </div> */}

            {textGroupKeys?.[0] && (
              <div className="grid-end-12 md:grid-end-8 md:grid-start-3">
                {textGroupKeys.map((textGroupKey, textGroupIndex) => {
                  const key = `text-group-${textGroupIndex}`;
                  const textGroup = textGroups[textGroupKey];

                  return (
                    <div
                      key={key}
                      id={`${textGroup.id}`}
                      ref={textGroup.ref}
                      className="whitespace-pre-wrap b1 text-left"
                    >
                      <PortableText blocks={textGroup._rawContent} />
                    </div>
                  );
                })}
              </div>
            )}
          </article>
        </section>
      </Layout>

      <Footer />
    </>
  );
};

export default TermsPage;

export const query = graphql`
  query Terms {
    sanityTerms {
      title

      textGroups {
        _rawContent
        id
      }

      seoDescription
      seoKeywords
    }
  }
`;
